import { render, staticRenderFns } from "./RegisterPanel.vue?vue&type=template&id=80f9d540&scoped=true&"
import script from "./RegisterPanel.vue?vue&type=script&lang=js&"
export * from "./RegisterPanel.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPanel.vue?vue&type=style&index=0&id=80f9d540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f9d540",
  null
  
)

export default component.exports